var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 29.2656C22.2695 29.2656 21.3906 30.2324 21.3906 31.375C21.3906 32.6055 22.3574 33.4844 23.5 33.4844C24.6426 33.4844 25.5215 32.6055 25.5215 31.375C25.6094 30.2324 24.6426 29.2656 23.5 29.2656ZM23.5 25.75C24.2031 25.75 24.8184 25.1348 24.8184 24.3438V11.6875C24.8184 10.9844 24.1152 10.2812 23.5 10.2812C22.7969 10.2812 22.0938 10.9844 22.0938 11.6875V24.3438C22.0938 25.1348 22.709 25.75 23.5 25.75ZM45.2969 32.6055L27.7188 2.89844C26.8398 1.4043 25.2578 0.525391 23.5 0.4375C21.6543 0.4375 20.0723 1.4043 19.1934 2.89844L1.61523 32.6055C0.736328 34.0996 0.736328 35.8574 1.61523 37.3516C2.49414 38.9336 4.07617 39.8125 5.92188 39.8125H41.0781C42.8359 39.8125 44.418 38.9336 45.2969 37.3516C46.1758 35.8574 46.1758 34.0996 45.2969 32.6055ZM42.8359 35.9453C42.4844 36.6484 41.7812 37 40.9902 37H5.92188C5.13086 37 4.42773 36.6484 4.07617 35.9453C3.63672 35.3301 3.72461 34.627 4.07617 34.0117L21.6543 4.30469C22.0059 3.68945 22.709 3.25 23.5 3.25C23.5 3.25 23.4121 3.25 23.5 3.25C24.2031 3.33789 24.9062 3.68945 25.2578 4.30469L42.8359 34.0117C43.1875 34.627 43.2754 35.3301 42.8359 35.9453Z",
    fill: "#D60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.d4569600429f87d46e19531d5a73aa95.svg";
export { ForwardRef as ReactComponent };